/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { CommonActions } from "@app/store/common/common.actions";
import { CommonState } from "@app/store/common/common.state";
import { Store } from "@ngxs/store";

@Injectable({
  providedIn: "root",
})
export class PatientIdResolver implements Resolve<string | null> {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): string | null {
    // Get patientId from url
    const urlPatientId = route.paramMap.get("patientId") || null;

    if (urlPatientId !== this.store.selectSnapshot(CommonState.patientId)) {
      // New patient has been selected (or deseleted)
      // Update patient info in store
      this.store.dispatch(new CommonActions.SetPatientId({ patientId: urlPatientId }));
    }

    return urlPatientId;
  }
}
